import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@rensa/environments/environment';
import { Observable } from 'rxjs';
import { ListItem } from '@rensa/modules/customer/models/list-item.model';
import { Event } from '@rensa/modules/customer/models/event.model';
import { Person } from '@rensa/modules/customer/components/registration/registration.component';
import { ItemType } from '@rensa/shared/enums/item-type.enum';

@Injectable({
  providedIn: 'root',
})
export class ItemService {
  constructor(private http: HttpClient) {}

  fetchAll(itemType: ItemType): Observable<ListItem[]> {
    return this.http.get<ListItem[]>(
      `${environment.apiBaseUrl}/items/${itemType}`
    );
  }

  fetchBy(id: string): Observable<ListItem> {
    return this.http.get<ListItem>(
      `${environment.apiBaseUrl}/items/details/${id}`
    );
  }

  fetchPreview(id: string): Observable<ListItem> {
    return this.http.get<ListItem>(`${environment.apiBaseUrl}/cms/items/details/${id}`);
  }

  fetchEvents(trainingId: string): Observable<Event[]> {
    return this.http.get<Event[]>(
      `${environment.apiBaseUrl}/items/${trainingId}/events`
    );
  }

  register(
    trainingId: string,
    eventId: string,
    person: Person
  ): Observable<Person> {
    return this.http.post<Person>(
      `${environment.apiBaseUrl}/items/${trainingId}/events/${eventId}/register`,
      person
    );
  }

  unregister(
    trainingId: string,
    eventId: string,
    userId: string
  ): Observable<Person> {
    return this.http.delete<Person>(
      `${environment.apiBaseUrl}/items/${trainingId}/events/${eventId}/${userId}`
    );
  }
}
